import axios from "axios";
import API from '@/services/API.js';
import {i18n, setI18nLang} from "../setup/i18n-setup";
import traductions from '@/services/traductions.js';

export const DEFAULT_LANG = 'fr';

/**
 *
 * @returns {string}
 */
export function getAppLang() {
  let lang = getLocaleLang();
  if (!lang) {
    lang = 'fr';
  }
  return lang;
}

/**
 *
 * @param hash
 * @returns {string}
 */
function getLocaleUserLang(hash) {
  return window.V.$localStorage.get(`BPZ_${hash}_LOCALE`);
}

/**
 * Récupère la langue du navigateur
 * @returns {string}
 */
function getNavigatorLang() {
  return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language
}

/**
 * Récupère en base de données la langue d'affichage pour l'utilisateur
 * @returns {Promise<undefined|*>}
 */
async function getUserSavedLang() {
  try {
    const results = await axios.get(API.endpoints.user.settings);
    return results.data.lang;
  } catch (e) {
    console.error(e);
    return undefined;
  }
}

/**
 * Enregistre la langue de l'utilisateur
 * @param {string} lang
 * @returns {Promise<string>}
 */
export async function saveUserLang(lang) {
  try {
    await axios.put(API.endpoints.user.settings, {lang});
  } catch (e) {
    console.error(e);
  }
}

/**
 *
 * @param {string} hash
 * @param {string} lang
 */
function saveLocaleUserLang(hash, lang) {
  window.V.$localStorage.set(`BPZ_${hash}_LOCALE`, lang);
}

/**
 *
 * @returns {string}
 */
function getLocaleLang() {
  return localStorage.bpz_lang;
}

/**
 * Sauvegarde la langue dans le Local Storage
 * @param {string} lang
 */
function saveLocaleLang(lang) {
  localStorage.bpz_lang = lang;
}

/**
 * Récupère la langue d'affichage
 * @param {string} user
 * @returns {Promise<string>}
 */
export async function getUserLang(user) {
  const sha1 = require('sha1');
  const hash = sha1(user);
  let lang = await getUserSavedLang();
  if (!lang) {
    lang = getLocaleUserLang(hash);
    if (!lang) {
      const navigatorLang = getNavigatorLang();
      lang = navigatorLang.split('-')[0];
      if (!lang) {
        lang = DEFAULT_LANG;
      }
    }
  }
  saveLocaleUserLang(hash, lang);
  saveLocaleLang(lang);
  return lang;
}

/**
 *
 * @param {string} lang
 */
export function loadLanguage(lang) {
  let messages = { ...traductions[lang]};
  setI18nLang(lang);
  i18n.setLocaleMessage(lang, messages);
}
